import React from 'react';
import st from './GroupedWorkItem.module.scss';
import { PlanFactCultivatedByGeoZone } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { IconBox, Type as T } from '@infobis/ui-styles-utils';
import WorkItem from "../../../../../components/WorkItem/WorkItem";

type GroupedWorkItemProps = {
    children: React.ReactNode
    value: PlanFactCultivatedByGeoZone
    openedGroups: number[]
    setOpenedGroups: (groupIds: number[]) => void
    barsSize?: number
}

const GroupedWorkItem = (props: GroupedWorkItemProps) => {
    const { value, children, setOpenedGroups, openedGroups, barsSize } = props;

    const isOpen = openedGroups.includes(value.groupId)

    const toggleGroup = () => {
        isOpen
            ? setOpenedGroups(openedGroups.filter(groupId => groupId !== value.groupId))
            : setOpenedGroups([...openedGroups, value.groupId])
    }

    return (
        <div className={st['list']}>
            <div className={st['list__group-item']}>
                <IconBox style={{ cursor: 'pointer', width: 24 }}
                         size={T.Sizes.L}
                         icon={isOpen ? T.IconName.ChevronUp : T.IconName.ChevronDown}
                         onClick={toggleGroup}
                />
                <WorkItem
                    type={'group'}
                    onTitleClick={toggleGroup}
                    barsWidth={barsSize}
                    work={{
                        season: {cropPeriods: [], cultivatedArea: value.season.fact, totalArea: value.season.plan},
                        today: {cropPeriods: [], cultivatedArea: value.today.fact, totalArea: value.today.plan},
                        displayName: value.groupName || '',
                    }}
                />
            </div>
            {isOpen && <div className={st['children']}>{children}</div>}
        </div>
    )
}

export default GroupedWorkItem;